import React, { useEffect, useMemo } from 'react';
import { Link, Box, Typography, Select, MenuItem, Chip } from '@mui/material';
import { useSelector, useDispatch} from 'react-redux';

import KPTable from '../../../components/KPTComponents/KPTable';

import { councilActions, formActions, userActions } from '../../../actions';
import { COLOR_PALETTE, CRUD_LABELS, CRUD_MODELS, EDUCATE_DEGREE_CONSTANTS, FORM_CONSTANTS, FORM_MODEL_DANH_GIA, HEADERS, ROUTER, SCIENTIFIC_RESEARCH_CONSTANTS, USER_CONSTANTS } from '../../../constants';
import { apiCall, downloadFile, fileRender, toPlural } from '../../../utils';
import { textFormDanhGia } from '../../DangKyHoSo/utils';
import { getError, getValue } from '../../../components/KPTComponents/KPTextform/utils';

const OPTIONS = [
  ...SCIENTIFIC_RESEARCH_CONSTANTS.FILTER_TYPE,
  {
    key: CRUD_MODELS.MONOGRAPH,
    value: CRUD_MODELS.MONOGRAPH,
    title: CRUD_LABELS[CRUD_MODELS.MONOGRAPH],
  },
  {
    key: CRUD_MODELS.SOLUTION,
    value: CRUD_MODELS.SOLUTION,
    title: CRUD_LABELS[CRUD_MODELS.SOLUTION],
  },
  {
    key: CRUD_MODELS.AWARD,
    value: CRUD_MODELS.AWARD,
    title: CRUD_LABELS[CRUD_MODELS.AWARD],
  },
];

export default function DanhSachHoSoTable() {
	const dispatch = useDispatch();

  const list = useSelector(state => state.formReducer.list);
	const loading = useSelector(state => state.formReducer.loading);
  const profile = useSelector(state => state.profileReducer.profile);
  const councils = useSelector(state => state.councilReducer.councils);
  const users = useSelector(state => state.userReducer.filterData?.list);

  // const councils = formReducer?.form?.councils || [];
  // console.log("councils", councils); 

  const thamDinhMap = useMemo(() => {
    const councils_item = councils?.[0]?.applicationForms || [];
    // for applicationForms create map thamDinhCode
    const thamDinhMap = {};
    councils_item.forEach((item) => {
      const council = item.councils.find((c) => c?.profileId === profile?.id);
      thamDinhMap[item.id] = council?.code || "";
    });
    return thamDinhMap;
  }, [councils]);

  // console.log("thamDinhMap", thamDinhMap);

  const [thamDinh1, setThamDinh1] = React.useState(null);
  const [thamDinh2, setThamDinh2] = React.useState(null);
  const [thamDinh3, setThamDinh3] = React.useState(null);
  
  const listCouncilUsers = useMemo(() => {
    if (!users) return [];
    return users?.filter(user => user?.role !== USER_CONSTANTS.ROLE.candidate && !user?.username.includes('admin')).map(user => ({
      value: user.profile?.id || 0,
      label: user.profile?.name || user.email,
    }));
  }, [users]);

  const rowStatusChamDiem = useMemo(() => {
    return [
      FORM_CONSTANTS.CHAM_DIEM_MAP.none,
      FORM_CONSTANTS.CHAM_DIEM_MAP.assigned,
      FORM_CONSTANTS.CHAM_DIEM_MAP.completed
    ];
  }, []);

  const rowStatusDanhGia = useMemo(() => {
    return [
      FORM_CONSTANTS.DANH_GIA_MAP.none,
      FORM_CONSTANTS.DANH_GIA_MAP.assigned,
      FORM_CONSTANTS.DANH_GIA_MAP.completed
    ];
  }, []);
  const rowStatusThamDinh = useMemo(() => {
    return [
      FORM_CONSTANTS.THAM_DINH_MAP.none,
      FORM_CONSTANTS.THAM_DINH_MAP.assigned,
      FORM_CONSTANTS.THAM_DINH_MAP.completed
    ];
  }, []);
  // console.log('listCouncilUsers', list, councils);

  const checkIfDuplicateThamDinh = (profileId, formId, rank) => {
    if (rank === 'tham_dinh_1') {
      const check2 = thamDinh2?.find(item => item.profileId === profileId && item.id === formId);
      const check3 = thamDinh3?.find(item => item.profileId === profileId && item.id === formId);
      if (check2 || check3) {
        dispatch(userActions.notification({ message: 'Không được chọn trùng người thấm định', type: 'warning' }));
        return true;
      }
    } else if (rank === 'tham_dinh_2') {
      const check1 = thamDinh1?.find(item => item.profileId === profileId && item.id === formId);
      const check3 = thamDinh3?.find(item => item.profileId === profileId && item.id === formId);
      if (check1 || check3) {
        dispatch(userActions.notification({ message: 'Không được chọn trùng người thấm định', type: 'warning' }));
        return true;
      }
    } else if (rank === 'tham_dinh_3') {
      const check1 = thamDinh1?.find(item => item.profileId === profileId && item.id === formId);
      const check2 = thamDinh2?.find(item => item.profileId === profileId && item.id === formId);
      if (check1 || check2) {
        dispatch(userActions.notification({ message: 'Không được chọn trùng người thấm định', type: 'warning' }));
        return true;
      }
    }
    return false;
  };

  const updateCouncil = (profileId, formId, rank) => {
    if (checkIfDuplicateThamDinh(profileId, formId, rank)) return; // Check for duplicate thẩm định
    // console.log('updateCouncil', profileId, formId, rank);
    if (!profileId || !formId || !rank) return;
    const roleValues = {
      profileId: profileId,
      applicationFormIds: [formId],
      code: rank
    };
    dispatch(councilActions.update(roleValues)).then(
      // console.log('Cập nhật hội đồng thành công'),
      updateThamDinhFromState(profileId, formId, rank), // Update thamDinh1 state
      // handleReload
    );
  };

  const updateThamDinhFromState = (profileId, formId, rank) => {
    if (rank == 'tham_dinh_1') {
      setThamDinh1(prev => {
        return prev.map(item => {
          if (item.id === formId) {
            return { ...item, profileId: profileId };
          }
          return item;
        });
      });
    }
    else if (rank == 'tham_dinh_2') {
      setThamDinh2(prev => {
        return prev.map(item => {
          if (item.id === formId) {
            return { ...item, profileId: profileId };
          }
          return item;
        });
      });
    } else if (rank == 'tham_dinh_3') {
      setThamDinh3(prev => {
        return prev.map(item => {
          if (item.id === formId) {
            return { ...item, profileId: profileId };
          }
          return item;
        });
      });
    }
  };

  const handleReload = () => {
    if (profile?.userRole === USER_CONSTANTS.ROLE.council) {
      dispatch(councilActions.filter({ profileId: profile.id, page: 1, pageSize: 10000 }));
      dispatch(userActions.filter({ page: 1, pageSize: 10000 }));
    } else if (profile?.userRole === USER_CONSTANTS.ROLE.super_admin) {
      dispatch(formActions.getAllApplicationForm());
      dispatch(userActions.filter({ page: 1, pageSize: 10000 }));
    }
  };

  const exportFile = async (endPoint) => {
    dispatch(userActions.setLoadingGlobal(true));

    const { response, error } = await apiCall({
      endPoint: '/api/v1/export' + endPoint,
      method: 'GET',
      headers: HEADERS.DEFAULT_HEADER,
    });
    
    if (!error && response.status === 200) {
      downloadFile(fileRender(response.data.data));
    } else {
      dispatch(userActions.notification({ message: 'Xuất dữ liệu thất bại', type: 'error' }));
    }

    dispatch(userActions.setLoadingGlobal(false));
  }

  useEffect(() => {
    if (!profile?.userRole) return;
    
    if (profile.userRole === USER_CONSTANTS.ROLE.council) {
      dispatch(councilActions.filter({ profileId: profile.id, page: 1, pageSize: 10000 }))
      dispatch(userActions.filter({ page: 1, pageSize: 10000 }));
    } else if (profile.userRole === USER_CONSTANTS.ROLE.super_admin) {
      dispatch(formActions.getAllApplicationForm());
      dispatch(userActions.filter({ page: 1, pageSize: 10000 }));
    }
  }, [profile]);

  const validate = (values, textform) => {
    // console.log("validate", values, textform);
    for (const elm of textform) {
      const err = getError(values, elm);
    // console.log('elm', elm, getValue(values, elm), err);
      if (!!err) {
        // console.log('validate error', err, elm);
        // // setError({ key: elm.key, value: err });
        // // jumpToReleventDiv(elm.key);
        // dispatch(
        //   userActions.notification({
        //     message: `Không được để trống thông tin về: ${elm.label}`,
        //     type: "error",
        //   })
        // );
        // window.history.pushState(null, null, `#${elm.key}`);
        return false;
      }
    }

    return true;
  };


  const rows = useMemo(() => {
    if (profile.userRole) {
      if (profile.userRole === USER_CONSTANTS.ROLE.council && councils) {
        const forms = councils.find((c) => c.profileId === profile.id)?.applicationForms;
        const finalForms = [];
        // check phan bien khai in forms
        if (forms && forms.length > 0) {
          forms.forEach((form) => {
            const councils = form.councils || [];
            const council = councils.find((c) => c?.profileId === profile?.id);
            const values = form;
            if (council?.id) {
              let textFormA0 = [];
              if (values && values?.entity === "gv") {
                textFormA0 = textFormDanhGia.mucA0.filter(
                  (item) => item.key == "giangVien"
                );
              }
              if (values && values?.entity === "gvtg") {
                textFormA0 = textFormDanhGia.mucA0.filter(
                  (item) => item.key == "giangVienThinhGiang"
                );
              }
              let textFormA9 = [];
              const educateDegrees = values?.educateDegrees || [];
              educateDegrees.forEach((item) => {
                const degreeType = item.degreeType;
                const degree = EDUCATE_DEGREE_CONSTANTS.TYPE_OPTIONS.find(
                  (option) => option.key === degreeType
                )?.title;
                if (degree) {
                  textFormA9.push({
                    ...FORM_MODEL_DANH_GIA.trinhDoDaoTao,
                    key: `${degreeType}`,
                    label: `Bằng cấp ${degree}`,
                    required: true,
                    xs: 12,
                  });
                }
              });
              let textFormA10 = [];
              if (values?.pgsStartTime && values?.pgsStartTime !== "") {
                textFormA10.push({
                  ...FORM_MODEL_DANH_GIA.congNhanPgs,
                  key: `ngayCongNhanPhoGiaoSu`,
                  label: `Ngày công nhận PGS`,
                  required: true,
                  xs: 12,
                });
              }
              if (values?.pgsMajor && values?.pgsMajor !== "") {
                textFormA10.push({
                  ...FORM_MODEL_DANH_GIA.congNhanPgs,
                  key: `nganhPhoGiaoSu`,
                  label: `Chuyên ngành PGS`,
                  required: true,
                  xs: 12,
                });
              }
              // B2
              // console.log('values?.educateProcess', JSON.parse(values?.educateProcess));
              let mucB2 = [];
              if (values?.educateProcess) {
                for (const [key, item] of Object.entries(JSON.parse(values?.educateProcess))) {
                  mucB2.push({
                    ...FORM_MODEL_DANH_GIA.thoiGianDaoTao,
                    key: `nam${item.id + 1}`,
                    label: `Thời gian đào tạo ${item.schoolYear}`,
                    required: true,
                    xs: 6,
                  });
                }
              }
              const validateTextForm = [
                ...textFormA0,
                ...textFormA9,
                ...textFormA10,
                ...textFormDanhGia.mucB1,
                ...mucB2,
                ...textFormDanhGia.mucB3,
                ...textFormDanhGia.mucC,
                ...textFormDanhGia.mucNhanXet,
              ];
              const thamDinhData = council?.phanBienKhai || {};
              const phanBienKhai = {
                ...council?.phanBienKhai,
                daiHoc: thamDinhData?.bangDaiHoc || "",
                thacSi: thamDinhData?.bangThacSi || "",
                tienSi: thamDinhData?.bangTienSi || "",
                TSKH: thamDinhData?.bangTienSiKhoaHoc || "",
                PGS: thamDinhData?.bangPhoGiaoSu || "",
              }
              const validatedForm = validate(phanBienKhai, validateTextForm);
              // if (!validatedForm) {
              // console.log('validatedForm', validatedForm, council?.phanBienKhai, phanBienKhai, validateTextForm);
              // }
              const tmpData = form;
              const res = {};
              const resAll = {};
              OPTIONS.forEach((option) => {
                var rows;
                // if (form.id === 352) {
                //   console.log(toPlural(option.key))
                // }
                if (form.hasOwnProperty(toPlural(option.key))){
                  rows = form[toPlural(option.key)];
                }
                else
                  rows = form.scientificResearchs.filter(
                    (e) => e.filterType === option.key
                  );
                rows = rows || [];
                // if (form.id === 352) {
                //   console.log(rows,option.key)
                // }
                rows.map((row) => {
                  const thamDinhCode = thamDinhMap[form.id];
                  let thamDinhData = {};
                  if (thamDinhCode === "tham_dinh_1") {
                    thamDinhData = row?.thamDinh1Data
                    ? JSON.parse(row?.thamDinh1Data || "{}")
                    : row;
                    row.notEligible = thamDinhData?.notEligible;
                  } else if (thamDinhCode === "tham_dinh_2") {
                    thamDinhData = row?.thamDinh2Data
                      ? JSON.parse(row?.thamDinh2Data || "{}")
                      : row;
                      row.notEligible = thamDinhData?.notEligible;
                    } else if (thamDinhCode === "tham_dinh_3") {
                      thamDinhData = row?.thamDinh3Data
                      ? JSON.parse(row?.thamDinh3Data || "{}")
                      : row;
                      row.notEligible = thamDinhData?.notEligible;
                    }
                    return row;
                  });
                res[option.key] = rows.filter((e) => (!e?.scoringTable?.accepted && !e?.notEligible))?.length;
                resAll[option.key] = rows.length;
              });
              // if (form.id === 352) {
              // console.log('res', res);
              // }
              // get sum of res values
              tmpData.unAcceptedCounter = Object.values(res).reduce((a, b) => a + b, 0);
              tmpData.allCounter = Object.values(resAll).reduce((a, b) => a + b, 0);
              if (!validatedForm) {
                tmpData.color = 'antiquewhite';
              } else {
                tmpData.color = 'lightgreen';
              }
              // check all element is council.phanBienKhai dont have value
              if (Object.values(council?.phanBienKhai || {}).every(x => !x)) {
                tmpData.color = '#ffffff';
              }
              finalForms.push(tmpData);
            }
          });
          // console.log('finalForms', finalForms);
        }
        return finalForms
      }
      return list.filter((item) => item.isShow);
    }
    return [];
  }, [profile, list, councils]);

  // setThamDinh
  useEffect(() => {
    if (rows && rows.length > 0) {
      const thamDinh1 = rows.map((item) => {
        const council = item.councils?.find(c => c.code === 'tham_dinh_1');
        return {
          id: item.id,
          profileId: council?.profileId || '',
        };
      });
      setThamDinh1(thamDinh1);
      const thamDinh2 = rows.map((item) => {
        const council = item.councils?.find(c => c.code === 'tham_dinh_2');
        return {
          id: item.id,
          profileId: council?.profileId || '',
        };
      });
      setThamDinh2(thamDinh2);
      const thamDinh3 = rows.map((item) => {
        const council = item.councils?.find(c => c.code === 'tham_dinh_3');
        return {
          id: item.id,
          profileId: council?.profileId || '',
        };
      });
      setThamDinh3(thamDinh3);
    }
  }, [rows]);

	const columns = [
		{ title: <b>STT</b>, dataIndex: 'id', width: '5%', render: (_, row, id) => id + 1 },
		{ title: <b>Tên ứng viên</b>, dataIndex: 'profile', width: '20%', render: (value) => (
      <>
        <Typography variant='body2' color={COLOR_PALETTE.PRIMARY}><b>{value?.name}</b></Typography>
        <Typography variant='body2' color='grey'>{value?.email}</Typography>
      </>
    ) },
    {
      title: <b>Chuyên ngành</b>,
      dataIndex: 'major',
      width: '15%',
      filters: FORM_CONSTANTS.MAJOR_OPTIONS,
      render: (value) => FORM_CONSTANTS.MAJOR_OPTIONS.find((e) => e.value === value)?.title,
      onFilter: (value, row) => row.role === value,
    },
		{
      title: <b>Ngành chuyên sâu</b>,
      dataIndex: 'specialization',
      width: '15%',
      render: (value, row) => FORM_CONSTANTS.SPECIALIZATION_OPTIONS?.[row.major]?.find((e) => e.value === value)?.title,
    },
    {
      title: <b>Thẩm định 1</b>,
      dataIndex: 'appraiser1',
      width: '20%',
      render: (value, row) => (
        <Select
          id="demo-simple-select-autowidth-label"
          size='small'
          value={thamDinh1?.find((e) => e.id === row.id)?.profileId || ''}
          style={{ width: '100%' }}
          disabled={profile?.userRole !== USER_CONSTANTS.ROLE.super_admin}
          onChange={(e) => updateCouncil(e.target.value, row.id, "tham_dinh_1")}
        >
          {listCouncilUsers.map((type) => (
            <MenuItem key={type.id} value={type.value}>{type.label}</MenuItem>
          ))}
        </Select>
      ),
    },
    {
      title: <b>Thẩm định 2</b>,
      dataIndex: 'appraiser2',
      width: '20%',
      render: (value, row) => (
        <Select
          id="demo-simple-select-autowidth-label"
          size='small'
          value={thamDinh2?.find((e) => e.id === row.id)?.profileId || ''}
          style={{ width: '100%' }}
          disabled={profile?.userRole !== USER_CONSTANTS.ROLE.super_admin}
          onChange={(e) => updateCouncil(e.target.value, row.id, "tham_dinh_2")}
        >
          {listCouncilUsers.map((type) => (
            <MenuItem key={type.id} value={type.value}>{type.label}</MenuItem>
          ))}
        </Select>
      ),
    },
    {
      title: <b>Thẩm định 3</b>,
      dataIndex: 'appraiser3',
      width: '20%',
      render: (value, row) => (
        <Select
          id="demo-simple-select-autowidth-label"
          size='small'
          value={thamDinh3?.find((e) => e.id === row.id)?.profileId || ''}
          style={{ width: '100%' }}
          disabled={profile?.userRole !== USER_CONSTANTS.ROLE.super_admin}
          onChange={(e) => updateCouncil(e.target.value, row.id, "tham_dinh_3")}
        >
          {listCouncilUsers.map((type) => (
            <MenuItem key={type.id} value={type.value}>{type.label}</MenuItem>
          ))}
        </Select>
      ),
    },
    ...(profile.userRole === USER_CONSTANTS.ROLE.council ? [{
      title: <b>Chấm điểm</b>,
      dataIndex: 'cham_diem',
      width: '18%',
      render: (value, row) => {
        let _status = 'assigned';
        if (row.allCounter - row.unAcceptedCounter === 0) {
          _status = 'none';
        }
        if (row.allCounter - row.unAcceptedCounter !== 0) {
          _status = 'assigned';
        }
        if (row.unAcceptedCounter === 0) {
          _status = 'completed';
        }

        return <Chip label={rowStatusChamDiem.find((type) => type.value === _status)?.label} style={{ backgroundColor: _status === 'none' ? 'lightgray' : _status === 'assigned' ? 'lightblue' : 'lightgreen' }} />
      }
    },
    {
      title: <b>Đánh giá</b>,
      dataIndex: 'danh_gia',
      width: '18%',
      render: (value, row) => {
        let _status = 'assigned';
        if (row.color === '#ffffff') {
          _status = 'none';
        }
        if (row.color === 'antiquewhite') {
          _status = 'assigned';
        }
        if (row.color === 'lightgreen') {
          _status = 'completed';
        }
        if (profile.userRole === USER_CONSTANTS.ROLE.council){
          return <Chip label={rowStatusDanhGia.find((type) => type.value === _status)?.label} style={{ backgroundColor: _status === 'none' ? 'lightgray' : _status === 'assigned' ? 'lightblue' : 'lightgreen' }} />
        }
      },
    },
    {
      title: <b>Tác vụ</b>,
      dataIndex: 'actions',
      width: '25%',
      render: (_, row) => (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
            {profile.userRole !== USER_CONSTANTS.ROLE.super_admin ? (
              <Typography
                color='primary'
                variant='body2'
                className='action-btn'
                onClick={() => exportFile('/6a/' + row.id)}
              >
                Xuất file 6A
              </Typography>
            ) : (
              <Typography
                color='primary'
                variant='body2'
                className='action-btn'
                onClick={() => exportFile('/6a-all/' + row.id)}
              >
                Xuất tất cả file 6A
              </Typography>
            )}
            <Typography
              color='primary'
              variant='body2'
              className='action-btn'
              onClick={() => exportFile('/' + row.id)}
            >
              Xuất file chấm
            </Typography>
            <Link href={`${ROUTER.CHI_TIET_HO_SO}/${row.id}`} className='action-btn'>Chi tiết hồ sơ</Link>
            {row.status === FORM_CONSTANTS.STATUS_MAP.submitted.value ? (
              <Link href={`${ROUTER.DANH_SACH_THANH_TICH}/${row.id}`} className='action-btn'>Chấm điểm sách/báo</Link>
            ) : (
              <Typography color='gray' variant='body2' className='action-btn'>Hồ sơ chưa cập nhật</Typography>
            )}
          </Box>
          {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              color='primary'
              variant='body2'
              className='action-btn'
            >
              {row.color === 'antiquewhite' && (
                <Typography color='red' variant='body2'>Hồ sơ chưa đánh giá</Typography>
              )}
            </Typography>
            <div style={{textAlign: 'right'}}>
            {row.status === FORM_CONSTANTS.STATUS_MAP.submitted.value ? (
              <Link href={`${ROUTER.DANH_SACH_THANH_TICH}/${row.id}`} className='action-btn'>Chấm điểm sách/báo</Link>
            ) : (
              <Typography color='gray' variant='body2' className='action-btn'>Hồ sơ chưa cập nhật</Typography>
            )}
            </div>
          </Box> */}
        </>
      )
    },
  ] : [
    {
      title: <b>Tác vụ</b>,
      dataIndex: 'actions',
      width: '25%',
      render: (_, row) => (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
            {profile.userRole !== USER_CONSTANTS.ROLE.super_admin ? (
              <Typography
                color='primary'
                variant='body2'
                className='action-btn'
                onClick={() => exportFile('/6a/' + row.id)}
              >
                Xuất file 6A
              </Typography>
            ) : (
              <Typography
                color='primary'
                variant='body2'
                className='action-btn'
                onClick={() => exportFile('/6a-all/' + row.id)}
              >
                Xuất tất cả file 6A
              </Typography>
            )}
            {/* <Typography
              color='primary'
              variant='body2'
              className='action-btn'
              onClick={() => exportFile('/' + row.id)}
            >
              Xuất file chấm
            </Typography> */}
            <Link href={`${ROUTER.CHI_TIET_HO_SO}/${row.id}`} className='action-btn'>Chi tiết hồ sơ</Link>
            {row.status === FORM_CONSTANTS.STATUS_MAP.submitted.value ? (
              <Link href={`${ROUTER.DANH_SACH_THANH_TICH}/${row.id}`} className='action-btn'>Chấm điểm sách/báo</Link>
            ) : (
              <Typography color='gray' variant='body2' className='action-btn'>Hồ sơ chưa cập nhật</Typography>
            )}
          </Box>
          {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              color='primary'
              variant='body2'
              className='action-btn'
            >
              {row.color === 'antiquewhite' && (
                <Typography color='red' variant='body2'>Hồ sơ chưa đánh giá</Typography>
              )}
            </Typography>
            <div style={{textAlign: 'right'}}>
            {row.status === FORM_CONSTANTS.STATUS_MAP.submitted.value ? (
              <Link href={`${ROUTER.DANH_SACH_THANH_TICH}/${row.id}`} className='action-btn'>Chấm điểm sách/báo</Link>
            ) : (
              <Typography color='gray' variant='body2' className='action-btn'>Hồ sơ chưa cập nhật</Typography>
            )}
            </div>
          </Box> */}
        </>
      )
    },
  ]),[]];

	return <KPTable nonBorder={false} loading={loading} columns={columns} rows={rows} />
}
